import defineComponent from 'flight';

function Blueshift() {

    this.defaultAttrs({
        initData: null
    });

    this._trackVipIfCurrent = function () {
        if (this.attr.initData.pageName === 'VIP') {
            blueshift.track('view', {
                products: [{
                    sku: this.attr.initData.itemId
                }]
            });
        }
    };

    this._trackAddWishlist = function (evt, payload) {
        blueshift.track('add_to_wishlist', {
            customer_id: this.attr.initData.memberId,
            product_id: payload.itemId
        });
    }
    this._trackSearch = function (evt, payload) {
        // only track search page results.
        // note: when we have a search page we have a search query as well
        if (this.attr.initData.pageName !== 'SearchResults') {
            return;
        }

        let ids = [];
        for (let idx in payload.sendUs) {
            if(payload && payload.sendUs[idx] && payload.sendUs[idx].items){
                ids = ids.concat(payload.sendUs[idx].items);
            }
        }
        blueshift.track('search', {
            keywords: this.attr.initData.searchQuery,
            product_ids: ids
        });
    }

    this._initJsInclude = function () {
        if (window.blueshift) {
            blueshift.pageload();
            this._trackVipIfCurrent();
            return;
        }

        window._blueshiftid = '29d1e4a9929a3d3aa324ce6eb0cc9322'; window.blueshift = window.blueshift || []; if (blueshift.constructor === Array) { blueshift.load = function () { let d = function (a) { return function () { blueshift.push([a].concat(Array.prototype.slice.call(arguments, 0))) } },
            e = ['identify', 'track', 'click', 'pageload', 'capture', 'retarget']; for (let f = 0; f < e.length; f++) {blueshift[e[f]] = d(e[f])} }; }
        blueshift.load();
        blueshift.pageload();
        if (blueshift.constructor === Array) { (function () { let b = document.createElement('script'); b.type = 'text/javascript', b.async = !0, b.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//cdn.getblueshift.com/blueshift.js'; let c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(b, c); })() }

        // log user logged in. with pajax this call won't be done again until full page reload
        if (this.attr.initData.memberId) {
            blueshift.identify({
                customer_id: this.attr.initData.memberId,
                email: this.attr.initData.memberEmail,
                firstname: this.attr.initData.memberFirstName,
                lastname: this.attr.initData.memberLastName
            });
        }
        this._trackVipIfCurrent();
    }

    this.after('initialize', function () {
        this._initJsInclude();
        this.on('ui:item:on-add-to-wish-list', this._trackAddWishlist);
        this.on('ui:items-in-viewport:on-send-items', this._trackSearch);
    });
}

module.exports = defineComponent.component(Blueshift);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/blueshift.js